import React from "react";
import NavBar from "../../components/navBar/NavBar";
import axios from "axios";
import "../../assets/style/style.css";
import swal from "sweetalert";
import ReactFileReader from "react-file-reader";
import ptBr from "moment/locale/pt-br";
import moment from "moment";
import MaskedInput from "react-text-mask";

import Submit from "../../components/submit/Submit";
import ImgCard from "../../components/imgCard/ImgCard.jsx";
import "react-dates/initialize";
import {
  //DateRangePicker,
  SingleDatePicker
  //DayPickerRangeController
} from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import io from "socket.io-client";
require("dotenv").config();
const url = process.env.REACT_APP_API_TASK;
const urlSocket = process.env.REACT_APP_API_SOCKET;
const socket = io(urlSocket);
class ActivityPOP extends React.Component {
  constructor(props) {
    super(props);
    this.HandleClickRadioService = this.handleClickRadioService.bind(this);
    this.deleteImgBd = this.deleteImgBd.bind(this);
    this.state = {
      id_pop: "",
      pop: "",
      endereco: "",
      complemento: "",
      bairro: "",
      telefone: "",
      data_chegada: "",
      hora_chegada: "",
      hora_liberacao: "",
      hora_saida: "",
      descricao: "",
      tipo_servico: "",
      observacao: "",
      pendencia: "",
      diagnostico: "",
      diagnostico_outro: "",
      solucao: "",
      solucao_outro: "",
      img: [],
      imgText: [],
      load: false
    };
  }

  componentWillMount() {
    moment.locale("pt-br", ptBr);
  }

  componentDidMount() {
    const objForm = {
      id: this.props.match.params.id,
      token: localStorage.getItem("token")
    };
    this.getActivityPOP(objForm);
  }

  startTask = () => {
    console.log("starta");
    const token = localStorage.getItem("token");
    const objForm = { id_rat_pop: this.props.match.params.id, token: token };

    axios
      .post(
        `${url}/inicioTask`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        socket.emit("newTask", "postDash");
        this.setState({
          status: "andamento"
        });
      });
  };

  pauseTask = () => {
    console.log("pausar");
    const token = localStorage.getItem("token");
    const objForm = { id_rat_pop: this.props.match.params.id, token: token };
    axios
      .post(
        `${url}/pauseTask`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        socket.emit("newTask", "postDash");
        this.setState({
          status: "pause"
        });
      });
  };

  getActivityPOP = objForm => {
    axios
      .post(
        `${url}/atividade_pop`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        if (response.data.rat_pop["0"].data_chegada) {
          this.setState({
            date: moment(response.data.rat_pop["0"].data_chegada)
          });
        }
        this.setState({
          id_pop: response.data.rat_pop["0"].id_pop,
          pop: response.data.rat_pop["0"].pop,
          endereco: response.data.rat_pop["0"].endereco,
          complemento: response.data.rat_pop["0"].complemento,
          bairro: response.data.rat_pop["0"].bairro,
          numero: response.data.rat_pop["0"].numero,
          telefone: response.data.rat_pop["0"].telefone,

          hora_chegada: response.data.rat_pop["0"].hora_chegada,
          hora_liberacao: response.data.rat_pop["0"].hora_liberacao,
          hora_saida: response.data.rat_pop["0"].hora_saida,
          descricao: response.data.rat_pop["0"].descricao,
          observacao: response.data.rat_pop["0"].observacao,
          tipo_servico: response.data.rat_pop["0"].tipo_servico,
          pendencia: response.data.rat_pop["0"].pendencia,
          solucao: response.data.rat_pop["0"].solucao,
          solucao_outro: response.data.rat_pop["0"].solucao_outro,
          diagnostico: response.data.rat_pop["0"].diagnostico,
          diagnostico_outro: response.data.rat_pop["0"].diagnostico_outro,
          img: response.data.fotos,
          imgText: response.data.fotos,
          status: response.data.rat_pop["0"].status,
          tecnico: response.data.rat_pop["0"].tecnico
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  handleFiles = files => {
    files.base64.map(file => {
      this.setState({
        img: [...this.state.img, file]
      });
      return true;
    });
    return 0;
  };

  handleClickRadiopendencia = event => {
    console.log(event.target.value);
    this.setState({ pendencia: event.target.value });
  };

  handleClickRadioDiagnostico = event => {
    this.setState({ diagnostico: event.target.value, diagnostico_outro: "" });
  };

  handleClickRadioSolucao = event => {
    this.setState({ solucao: event.target.value, solucao_outro: "" });
  };

  handleClickRadioService(event) {
    this.setState({
      pendencia: "",
      diagnostico: "",
      solucao: "",
      diagnostico_outro: "",
      solucao_outro: ""
    });
    this.setState({ tipo_servico: event.target.value });
  }

  postForm = () => {
    this.setState({ load: true });

    const objForm = {
      token: localStorage.getItem("token"),
      id: this.props.match.params.id,
      id_pop: this.refs.id_pop.value,
      tecnico: this.state.tecnico,
      endereco: this.refs.endereco.value,
      complemento: this.refs.complemento.value,
      bairro: this.refs.bairro.value,
      telefone: this.refs.telefone.value,
      numero: this.refs.telefone.numero,
      //data_chegada: moment(this.state.date).format("L"),
      data_chegada: moment(this.state.date).format("YYYY-MM-DD"),
      hora_chegada: this.state.hora_chegada,
      hora_liberacao: this.state.hora_liberacao,
      hora_saida: this.state.hora_saida,
      descricao: this.state.descricao,
      tipo_servico: this.state.tipo_servico,
      observacao: this.state.observacao,
      img64: this.state.img,
      img64Text: this.state.imgText,
      pendencia: this.state.pendencia,
      diagnostico: this.state.diagnostico,
      diagnostico_outro: this.refs.hasOwnProperty("diagnostico_outro")
        ? this.refs.diagnostico_outro.value
        : "",
      solucao: this.state.solucao,
      solucao_outro: this.refs.hasOwnProperty("solucao_outro")
        ? this.refs.solucao_outro.value
        : ""
    };
    if (socket.connected) {
      axios
        .post(
          url + "/rat_pop",
          {
            objForm: objForm
            //nome : 'bruno'
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8"
            }
          }
        )
        .then(response => {
          //console.log(response.data);
          this.setState({ load: false });
          socket.emit("newTask", "postDash");
          if (response.data === 1) {
            swal({
              title: "Salvo",
              text: "Dados enviados!",
              icon: "success"
            }).then(willDelete => {
              if (willDelete) {
                window.location.reload();
              }
            });
          } else {
            swal("Não Salvo", " Ocorreu erro ao Salvar ", "error");
            //this.setState({load:false});
          }
        })
        .catch(function(error) {
          console.log(error);
          swal("Não Salvo", " Ocorreu erro ao Salvar ", "error");
        });
    } else {
      let arrayLocal = [];
      if (localStorage.getItem("dadosPop")) {
        arrayLocal = JSON.parse(localStorage.getItem("dadosPop"));
        arrayLocal.push(objForm);
      } else {
        arrayLocal.push(objForm);
      }
      arrayLocal = JSON.stringify(arrayLocal);
      localStorage.setItem("dadosPop", arrayLocal);
      swal({
        title: "Salvo",
        text: "Dados Salvos no aparelho, sem conectividade com a internet!",
        icon: "success"
      }).then(willDelete => {
        if (willDelete) {
          window.location.reload();
        }
      });
      this.setState({ load: false });
    }
  };

  handleInputChange = e => {
    //console.log(e);
    const key = e.target.name;
    console.log(e);
    //this.setState({ observacao: e.target.value });
    this.setState({ [key]: e.target.value });
  };

  handleInputChangeText = e => {
    let typeIMG = e.target.name;
    let indice = e.target.id;
    let value = e.target.value;
    if (this.state[typeIMG]) {
      let array = this.state[typeIMG];
      array[indice] = { ...array[indice], descricao: value };
      this.setState({ [typeIMG]: array });
    } else {
      let array = [];
      array[indice] = { descricao: value };
      this.setState({ [typeIMG]: array });
    }
  };

  handleInputChangeHora = e => {
    const key = e.target.id;
    this.setState({ [key]: e.target.value });
  };

  deleteImgBd = key => {
    let array = this.state.img;
    swal({
      title: "Você tem Certeza ?",
      text: " Está imagem será deletada!",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancelar", true]
    }).then(willDelete => {
      if (willDelete) {
        if (array[key].foto) {
          const objForm = {
            foto: array[key],
            token: localStorage.getItem("token")
          };

          axios
            .post(
              url + "/rat_pop_delete_foto",
              {
                objForm: objForm
                //nome : 'bruno'
              },
              {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8"
                }
              }
            )
            .then(response => {
              //console.log(response.data);
              if (response.data === 1) {
                this.setState({ load: false });
                swal("Deletado!", "Imagem Deletada!", "success");
              } else {
                swal("Falha!", "Não foi possivel excluir a imagem!", "error");
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        }

        array.splice(key, 1);
        this.setState({ img: "" });
        this.setState({ img: array });
      }
    });
  };

  deleteImg = (key, input, bd) => {
    //let inputText = input + "Text";

    //let array = this.state[input];
    let array = this.state.img;
    if (bd !== true) {
      array[key] = "";

      console.log(array);
      this.setState({ [input]: "" });
      this.setState({ [input]: array });
    } else {
      swal({
        title: "Você tem Certeza ?",
        text: " Está imagem será deletada!",
        icon: "warning",
        dangerMode: true,
        buttons: ["Cancelar", true]
      }).then(willDelete => {
        if (willDelete) {
          if (array[key].foto) {
            const objForm = {
              foto: array[key],
              token: localStorage.getItem("token")
            };
            axios
              .post(
                url + "/rat_pop_delete_foto",
                {
                  objForm: objForm
                  //nome : 'bruno'
                },
                {
                  headers: {
                    "Content-Type": "application/json;charset=UTF-8"
                  }
                }
              )
              .then(response => {
                if (response.data === 1) {
                  this.setState({ load: false });
                  swal("Deletado!", "Imagem Deletada!", "success");
                  array[key] = "";
                  this.setState({ [input]: array });
                } else {
                  swal("Falha!", "Não foi possivel excluir a imagem!", "error");
                }
              })
              .catch(function(error) {
                console.log(error);
              });
          }
        } else {
          this.setState({ [input]: "" });
          this.setState({ [input]: array });
        }
      });
    }
  };

  typeService() {
    if (this.state.tipo_servico === "instalacao") {
      return (
        <React.Fragment>
          <div
            className="form-group"
            onChange={this.handleClickRadiopendencia.bind(this)}
          >
            <label>
              {!this.state.pendencia ? (
                <span className="text-danger">
                  Instalação concluída sem pendências ? *
                </span>
              ) : (
                <React.Fragment>
                  Instalação concluída sem pendências ?
                </React.Fragment>
              )}
            </label>

            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="pendencia"
                ref="pendencia"
                id="id_pendencia_instalacao1"
                value="sim"
                checked={this.state.pendencia === "sim"}
                onChange={this.handleClickRadiopendencia.bind(this)}
              />
              <label
                className="form-check-label"
                htmlFor="id_pendencia_instalacao1"
              >
                Sim
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="pendencia"
                id="id_pendencia_instalacao2"
                ref="pendencia"
                value="nao"
                checked={this.state.pendencia === "nao"}
                onChange={this.handleClickRadiopendencia.bind(this)}
              />
              <label
                className="form-check-label"
                htmlFor="id_pendencia_instalacao2"
              >
                Não
              </label>
            </div>
          </div>
        </React.Fragment>
      );
    } else if (this.state.tipo_servico === "retirada") {
      return (
        <React.Fragment>
          <div className="form-group">
            <label>
              {!this.state.pendencia ? (
                <span className="text-danger">
                  Retirada concluída sem pendências ? *
                </span>
              ) : (
                <React.Fragment>
                  Retirada concluída sem pendências ?
                </React.Fragment>
              )}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="pendencia"
                ref="pendencia"
                id="id_pendencia_retirada1"
                value="sim"
                checked={this.state.pendencia === "sim"}
                onChange={this.handleClickRadiopendencia.bind(this)}
              />
              <label
                className="form-check-label"
                htmlFor="id_pendencia_retirada1"
              >
                Sim
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="pendencia"
                ref="pendencia"
                id="id_pendencia_retirada2"
                value="nao"
                checked={this.state.pendencia === "nao"}
                onChange={this.handleClickRadiopendencia.bind(this)}
              />
              <label
                className="form-check-label"
                htmlFor="id_pendencia_retirada2"
              >
                Não
              </label>
            </div>
          </div>
        </React.Fragment>
      );
    } else if (
      this.state.tipo_servico === "manutencao_preventiva" ||
      this.state.tipo_servico === "manutencao_corretiva" ||
      this.state.tipo_servico === "manutencao_emergencial"
    ) {
      return (
        <React.Fragment>
          <div className="form-group">
            <label>
              {!this.state.diagnostico ||
              (this.state.diagnostico === "outro" &&
                !this.state.diagnostico_outro) ? (
                <span className="text-danger">Diagnóstico do Serviço ? *</span>
              ) : (
                <React.Fragment>Diagnóstico do Serviço ?</React.Fragment>
              )}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="diagnostico1"
                value="cabo rompido"
                ref="diagnostico"
                name="diagnostico"
                onChange={this.handleClickRadioDiagnostico.bind(this)}
                checked={this.state.diagnostico === "cabo rompido"}
              />
              <label className="form-check-label" htmlFor="diagnostico1">
                Cabo rompido
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="diagnostico2"
                value="poe defeituoso"
                ref="diagnostico"
                name="diagnostico"
                onChange={this.handleClickRadioDiagnostico.bind(this)}
                checked={this.state.diagnostico === "poe defeituoso"}
              />
              <label className="form-check-label" htmlFor="diagnostico2">
                Poe defeituoso
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="diagnostico3"
                value="radio defeituoso"
                ref="diagnostico"
                name="diagnostico"
                onChange={this.handleClickRadioDiagnostico.bind(this)}
                checked={this.state.diagnostico === "radio defeituoso"}
              />
              <label className="form-check-label" htmlFor="diagnostico3">
                Rádio defeituoso
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="diagnostico4"
                value="conector defeituoso"
                ref="diagnostico"
                name="diagnostico"
                onChange={this.handleClickRadioDiagnostico.bind(this)}
                checked={this.state.diagnostico === "conector defeituoso"}
              />
              <label className="form-check-label" htmlFor="diagnostico4">
                Conector defeituoso
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="diagnostico5"
                value="rb defeituosa"
                ref="diagnostico"
                name="diagnostico"
                onChange={this.handleClickRadioDiagnostico.bind(this)}
                checked={this.state.diagnostico === "rb defeituosa"}
              />
              <label className="form-check-label" htmlFor="diagnostico5">
                RB defeituosa
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="diagnostico6"
                value="problema eletrico"
                ref="diagnostico"
                name="diagnostico"
                onChange={this.handleClickRadioDiagnostico.bind(this)}
                checked={this.state.diagnostico === "problema eletrico"}
              />
              <label className="form-check-label" htmlFor="diagnostico6">
                Problema elétrico
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="diagnostico7"
                value="antena defeituosa"
                ref="diagnostico"
                name="diagnostico"
                onChange={this.handleClickRadioDiagnostico.bind(this)}
                checked={this.state.diagnostico === "antena defeituosa"}
              />
              <label className="form-check-label" htmlFor="diagnostico7">
                Antena defeituosa
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="diagnostico8"
                value="outro"
                ref="diagnostico"
                name="diagnostico"
                onChange={this.handleClickRadioDiagnostico.bind(this)}
                checked={this.state.diagnostico === "outro"}
              />
              <label className="form-check-label" htmlFor="diagnostico8">
                Outro
                {!this.state.diagnostico_outro &&
                  this.state.diagnostico === "outro" && (
                    <span className="text-danger"> * </span>
                  )}
              </label>
            </div>
            <div className="form-group">
              {this.state.diagnostico === "outro" && (
                <input
                  type="text"
                  className="form-control"
                  id="inputAddress2"
                  name="diagnostico_outro"
                  ref="diagnostico_outro"
                  value={this.state.diagnostico_outro}
                  onChange={this.handleInputChange.bind(this)}
                />
              )}
            </div>
          </div>
          <div className="form-group">
            <label>
              {!this.state.solucao ||
              (this.state.solucao === "outro" && !this.state.solucao_outro) ? (
                <span className="text-danger"> Solução do Serviço ? * </span>
              ) : (
                <React.Fragment>Solução do Serviço ?</React.Fragment>
              )}
            </label>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="solucao1"
                value="substituição do cabeamento todo"
                ref="solucao"
                name="solucao"
                onChange={this.handleClickRadioSolucao.bind(this)}
                checked={
                  this.state.solucao === "substituição do cabeamento todo"
                }
              />
              <label className="form-check-label" htmlFor="solucao1">
                Substituição do cabeamento todo
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="solucao2"
                value="substituição do cabo porta POE"
                ref="solucao"
                name="solucao"
                onChange={this.handleClickRadioSolucao.bind(this)}
                checked={
                  this.state.solucao === "substituição do cabo porta POE"
                }
              />
              <label className="form-check-label" htmlFor="solucao2">
                Substituição do cabo porta POE
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="solucao3"
                value="substituição da fonte POE"
                ref="solucao"
                name="solucao"
                onChange={this.handleClickRadioSolucao.bind(this)}
                checked={this.state.solucao === "substituição da fonte POE"}
              />
              <label className="form-check-label" htmlFor="solucao3">
                Substituição da fonte POE
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="solucao4"
                value="substituiçao do Rádio"
                ref="solucao"
                name="solucao"
                onChange={this.handleClickRadioSolucao.bind(this)}
                checked={this.state.solucao === "substituiçao do Rádio"}
              />
              <label className="form-check-label" htmlFor="solucao4">
                Substituiçao do Rádio
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="solucao5"
                value="substituiçao Antena"
                ref="solucao"
                name="solucao"
                onChange={this.handleClickRadioSolucao.bind(this)}
                checked={this.state.solucao === "substituiçao Antena"}
              />
              <label className="form-check-label" htmlFor="solucao5">
                Substituiçao Antena
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="solucao6"
                value="substituição de estabilizador/nobreak"
                ref="solucao"
                name="solucao"
                onChange={this.handleClickRadioSolucao.bind(this)}
                checked={
                  this.state.solucao === "substituição de estabilizador/nobreak"
                }
              />
              <label className="form-check-label" htmlFor="solucao6">
                Substituição de estabilizador/nobreak
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="solucao7"
                value="substituição da fonte conversora AC/DC"
                ref="solucao"
                name="solucao"
                onChange={this.handleClickRadioSolucao.bind(this)}
              />
              <label className="form-check-label" htmlFor="solucao7">
                Substituição da fonte conversora AC/DC
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                id="solucao8"
                value="outro"
                ref="solucao"
                name="solucao"
                onChange={this.handleClickRadioSolucao.bind(this)}
                checked={this.state.solucao === "outro"}
              />
              <label className="form-check-label" htmlFor="solucao8">
                Outro
                {!this.state.solucao_outro &&
                  this.state.solucao === "outro" && (
                    <span className="text-danger"> * </span>
                  )}
              </label>
            </div>
            <div className="form-group">
              {this.state.solucao === "outro" && (
                <input
                  type="text"
                  className="form-control"
                  id="inputAddress2"
                  name="solucao_outro"
                  ref="solucao_outro"
                  value={this.state.solucao_outro}
                  onChange={this.handleInputChange.bind(this)}
                />
              )}
            </div>
          </div>
        </React.Fragment>
      );
    }
  }

  render() {
    return (
      <React.Fragment>
        <NavBar wayLast={`/task-descriptions/${this.props.match.params.id}`} />
        <div className="container-fluid container_body">
          <div className="containerCard">
            {this.state.status === "andamento" && (
              <React.Fragment>
                <div className="card marginTop6">
                  <button className="btn btn-danger" onClick={this.pauseTask}>
                    Pausar Tarefa
                  </button>
                </div>
              </React.Fragment>
            )}

            {(this.state.status === "pause" ||
              this.state.status === "pendente") && (
              <React.Fragment>
                <div className="card marginTop6">
                  <button className="btn btn-success" onClick={this.startTask}>
                    Inicar Tarefa
                  </button>
                </div>
              </React.Fragment>
            )}
            {this.state.status === "concluido" && (
              <React.Fragment>
                <center>
                  <div>
                    <div className="d-flex justify-content-center">
                      <div className="p-2 bd-highlight align-self-center">
                        <i
                          className="fas fa-check-circle fa-2x"
                          style={{ color: "green" }}
                        ></i>
                      </div>
                      <div className="p-2 bd-highlight align-self-center">
                        <b> Rat Concluída</b>
                      </div>
                    </div>
                  </div>
                </center>
              </React.Fragment>
            )}
            <div className="card marginTop6">
              <h5 className="card-header">Informaçoes do POP</h5>
              <div className="card-body">
                <div className="form-group">
                  <label>ID</label>
                  <input
                    type="text"
                    className="form-control"
                    id="inputAddress2"
                    ref="id_pop"
                    disabled
                    value={this.state.id_pop}
                    onChange={this.handleInputChange.bind(this)}
                  />
                </div>
                <div className="form-group">
                  <label>POP</label>
                  <input
                    type="text"
                    className="form-control"
                    id="inputAddress2"
                    ref="pop"
                    disabled
                    value={this.state.pop}
                    onChange={this.handleInputChange.bind(this)}
                  />
                </div>
                <div className="form-group">
                  <label>Endereço</label>
                  <input
                    type="text"
                    className="form-control"
                    id="endereco"
                    ref="endereco"
                    name="endereco"
                    defaultValue={this.state.endereco}
                    disabled
                    onChange={this.handleInputChange.bind(this)}
                  />
                </div>
                <div className="form-group">
                  <label>Complemento</label>
                  <input
                    type="text"
                    className="form-control"
                    id="inputAddress2"
                    ref="complemento"
                    name="complemento"
                    disabled
                    onChange={this.handleInputChange.bind(this)}
                    defaultValue={this.state.complemento}
                  />
                </div>
                <div className="form-group">
                  <label>Bairro</label>
                  <input
                    type="text"
                    className="form-control"
                    id="inputAddress2"
                    ref="bairro"
                    name="bairro"
                    disabled
                    onChange={this.handleInputChange.bind(this)}
                    defaultValue={this.state.bairro}
                  />
                </div>
                <div className="form-group">
                  <label>Numero</label>
                  <input
                    type="text"
                    className="form-control"
                    id="numero"
                    ref="numero"
                    name="numero"
                    disabled
                    defaultValue={this.state.numero}
                  />
                </div>
                <div className="form-group">
                  <label>Telefone</label>
                  <input
                    type="text"
                    className="form-control"
                    id="inputAddress2"
                    ref="telefone"
                    name="telefone"
                    disabled
                    onChange={this.handleInputChange.bind(this)}
                    defaultValue={this.state.telefone}
                  />
                </div>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">Data</h5>
              <div className="card-body">
                <div className="form-group">
                  <p>
                    Data da Chegada
                    {!this.state.date && (
                      <span className="text-danger"> * </span>
                    )}
                  </p>

                  <SingleDatePicker
                    date={this.state.date} // momentPropTypes.momentObj or null
                    onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                    focused={this.state.focused} // PropTypes.bool
                    onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                    id="your_unique_id" // PropTypes.string.isRequired,
                    displayFormat="DD/MM/YYYY"
                  />
                </div>
                <div className="form-group">
                  <label>
                    {!this.state.hora_chegada ? (
                      <span className="text-danger">Horário da Chegada * </span>
                    ) : (
                      <React.Fragment>Horário da Chegada</React.Fragment>
                    )}
                  </label>
                  <MaskedInput
                    mask={[/[0-2]/, /\d/, ":", /[0-5]/, /\d/]}
                    className="form-control"
                    placeholder="digite o horário"
                    guide={false}
                    id="hora_chegada"
                    onBlur={() => {}}
                    //onChange={() => {}}
                    value={this.state.hora_chegada}
                    onChange={this.handleInputChangeHora.bind(this)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {!this.state.hora_saida ? (
                      <span className="text-danger">Horário de Saída * </span>
                    ) : (
                      <React.Fragment>Horário de Saída</React.Fragment>
                    )}
                  </label>
                  <MaskedInput
                    mask={[/[0-2]/, /\d/, ":", /[0-5]/, /\d/]}
                    className="form-control"
                    placeholder="digite o horário"
                    guide={false}
                    id="hora_saida"
                    onBlur={() => {}}
                    //onChange={() => {}}
                    value={this.state.hora_saida}
                    onChange={this.handleInputChangeHora.bind(this)}
                  />
                </div>
                <div className="form-group">
                  <label>
                    {!this.state.hora_liberacao ? (
                      <span className="text-danger">
                        Horário de Liberação *
                      </span>
                    ) : (
                      <React.Fragment>Horário de Liberação</React.Fragment>
                    )}
                  </label>
                  <MaskedInput
                    mask={[/[0-2]/, /\d/, ":", /[0-5]/, /\d/]}
                    className="form-control"
                    placeholder="digite o horário"
                    guide={false}
                    id="hora_liberacao"
                    onBlur={() => {}}
                    //onChange={() => {}}
                    value={this.state.hora_liberacao}
                    onChange={this.handleInputChangeHora.bind(this)}
                  />
                </div>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">Descrição Serviço</h5>
              <div className="card-body">
                <div className="form-group">
                  <label>Descrição</label>

                  <textarea
                    className="form-control"
                    id="descricao"
                    rows="12"
                    name="descricao"
                    onChange={this.handleInputChange.bind(this)}
                    value={this.state.descricao}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label>Tipo de Serviço</label>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="tp_service"
                      id="exampleRadios1"
                      value="vistoria"
                      onChange={this.handleClickRadioService.bind(this)}
                      ref="tp_service"
                      checked={this.state.tipo_servico === "vistoria"}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="exampleRadios1"
                    >
                      Vistoria
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="tp_service"
                      id="rd_instalacao"
                      value="instalacao"
                      onChange={this.handleClickRadioService.bind(this)}
                      ref="tp_service"
                      checked={this.state.tipo_servico === "instalacao"}
                    />
                    <label className="form-check-label" htmlFor="rd_instalacao">
                      Instalação
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="tp_service"
                      id="rd_retirada"
                      value="retirada"
                      onChange={this.handleClickRadioService.bind(this)}
                      ref="tp_service"
                      checked={this.state.tipo_servico === "retirada"}
                    />
                    <label className="form-check-label" htmlFor="rd_retirada">
                      Retirada
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="tp_service"
                      id="rd_manutencao_preventiva"
                      value="manutencao_preventiva"
                      onChange={this.handleClickRadioService.bind(this)}
                      ref="tp_service"
                      checked={
                        this.state.tipo_servico === "manutencao_preventiva"
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="rd_manutencao_preventiva"
                    >
                      Manutenção Preventiva
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="tp_service"
                      id="rd_manutencao_corretiva"
                      value="manutencao_corretiva"
                      onChange={this.handleClickRadioService.bind(this)}
                      ref="tp_service"
                      checked={
                        this.state.tipo_servico === "manutencao_corretiva"
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="rd_manutencao_corretiva"
                    >
                      Manutenção Corretiva
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="tp_service"
                      id="rd_manutencao_emergencial"
                      value="manutencao_emergencial"
                      onChange={this.handleClickRadioService.bind(this)}
                      ref="tp_service"
                      checked={
                        this.state.tipo_servico === "manutencao_emergencial"
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="rd_manutencao_emergencial"
                    >
                      Manutenção Emergencial
                    </label>
                  </div>
                </div>
                {this.typeService()}
                <div className="form-group">
                  <label htmlFor="observacao">
                    {!this.state.observacao ? (
                      <span className="text-danger"> Observação * </span>
                    ) : (
                      <React.Fragment>Observação</React.Fragment>
                    )}
                  </label>
                  <textarea
                    onChange={this.handleInputChange.bind(this)}
                    className="form-control"
                    id="observacao"
                    name="observacao"
                    rows="3"
                    ref={textarea => {
                      this.observacao = textarea;
                    }}
                    value={this.state.observacao}
                  />
                </div>
              </div>
            </div>

            <div className="card marginTop6">
              <h5 className="card-header">Inserção de Fotos caso necessário</h5>
              <div className="card-body">
                <div className="form-group">
                  <ReactFileReader
                    handleFiles={this.handleFiles}
                    base64={true}
                    multipleFiles={true}
                    ref="fotosNecessaria"
                    name="fotosNecessaria"
                  >
                    <button className="btn btn-primary marginRight4">
                      Foto
                    </button>
                  </ReactFileReader>
                </div>

                <div className="form-group containerImg">
                  {this.state.img &&
                    this.state.img.map((img, i) =>
                      img.foto ? (
                        <div key={i}>
                          <ImgCard
                            description={img.descricao}
                            src={url + "/upload/" + img.foto}
                            clickDeleteImg={() =>
                              this.deleteImg(i, "img", true)
                            }
                            changeDescricao={e => this.handleInputChangeText(e)}
                            fieldName="imgText"
                            idName={i}
                          />
                        </div>
                      ) : (
                        <div key={i}>
                          <ImgCard
                            src={img}
                            clickDeleteImg={() => this.deleteImg(i, "img")}
                            changeDescricao={e => this.handleInputChangeText(e)}
                            fieldName="imgText"
                            idName={i}
                          />
                        </div>
                      )
                    )}
                </div>
              </div>
            </div>
            <div className="card marginTop6">
              <h5 className="card-header">Responsável </h5>
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="tecnico">Nome do Técnico</label>
                  <input
                    type="text"
                    className="form-control"
                    id="tecnico"
                    name="tecnico"
                    //onChange={this.handleInputChange.bind(this)}
                    defaultValue={this.state.tecnico}
                    readOnly
                  />
                </div>
              </div>
            </div>
            <center>
              {this.state.status === "concluido" && (
                <React.Fragment>
                  <center>
                    {this.state.status === "concluido" && (
                      <React.Fragment>
                        <center>
                          <div>
                            <div className="d-flex justify-content-center">
                              <div className="p-2 bd-highlight align-self-center">
                                <i
                                  className="fas fa-check-circle fa-2x"
                                  style={{ color: "green" }}
                                ></i>
                              </div>
                              <div className="p-2 bd-highlight align-self-center">
                                <b> Rat Concluída</b>
                              </div>
                            </div>
                          </div>
                        </center>
                      </React.Fragment>
                    )}
                  </center>
                </React.Fragment>
              )}
            </center>
            <div className="card marginTop6">
              <Submit
                load={this.state.load}
                submitClick={this.postForm}
                status={
                  this.state.status === "concluido" ||
                  this.state.status === "andamento"
                    ? false
                    : true
                }
              />
            </div>
            {this.state.status === "andamento" && (
              <React.Fragment>
                <div className="card marginTop6">
                  <button className="btn btn-danger" onClick={this.pauseTask}>
                    Pausar Tarefa
                  </button>
                </div>
              </React.Fragment>
            )}

            {(this.state.status === "pause" ||
              this.state.status === "pendente") && (
              <React.Fragment>
                <div className="card marginTop6">
                  <button className="btn btn-success" onClick={this.startTask}>
                    Inicar Tarefa
                  </button>
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ActivityPOP;
